<!-- 全域 Loading 狀態 -->
<ng-template #Loading>
  <div class="flex justify-content-center align-items-center h-screen">
    <p-progressSpinner ariaLabel="loading" />
  </div>
</ng-template>

<ng-container *ngIf="!isOptionLoading; else Loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'美容預約'"></app-nav-header>

  <div class="page-container p-3" [ngSwitch]="Step">
    
    <!-- Step 0: 同意書與簽名 -->
    <div *ngSwitchCase="0" class="step-content">
      <p-scrollPanel #consentFormScrollPanel [style]="{ width: '100%', height: '300px' }" styleClass="mb-3 border-1 surface-border border-round">
        <p class="p-3 m-0" [style]="{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }">{{ consentFormContent }}</p>
      </p-scrollPanel>
      
      <div class="flex flex-column gap-3">
        <div class="sign-box border-1 surface-border border-round overflow-hidden">
          <ngx-signature-pad #sig [options]="options" class="sign-canvas" 
            [class.disabled]="!isConsentFormRead"
            (beginSign)="onBegin()" (endSign)="onEnd()">
          </ngx-signature-pad>
        </div>
        <div class="p-2 w-full"> <!-- 增加一點 padding 防止按鈕貼死螢幕邊緣 -->
          <button pButton 
                  type="button"
                  label="清除簽名" 
                  icon="pi pi-trash" 
                  class="p-button-secondary w-full p-3 text-lg" 
                  [disabled]="!isConsentFormRead" 
                  (click)="clear()">
          </button>
        </div>
      </div>

      <div class="my-4 flex justify-content-center" style="text-align: center;">
        <p-checkbox name="agree" label="我已閱讀並同意此條款" [(ngModel)]="isAgreed" [binary]="true" [disabled]="!CheckSign()"></p-checkbox>
      </div>

      <app-button appClass="pageForm__btn w-full" (appClick)="nextStep(0)" appLabel="確定並下一步" [loading]="isLoading" [disabled]="!isAgreed"></app-button>
    </div>

    <!-- Step 1 & 2: 表單輸入區 (合併重複結構) -->
    <div *ngSwitchCase="Step === 1 || Step === 2 ? Step : -1" class="step-content">
      <form class="grid p-fluid">
        <!-- 第一步內容 -->
        <ng-container *ngIf="Step === 1">
          <div class="field col-12">
            <label starSign class="notice" for="Store">門市：</label>
            <p-dropdown *ngIf="StoreSelectList != null" [options]="StoreSelectList" [(ngModel)]="model.StoreNo" name="StoreNo" 
                    placeholder="請選擇門市" [showClear]="true" (ngModelChange)="ChooseStore()"></p-dropdown>
          </div>

          <div class="field col-12">
            <label starSign class="notice" for="PetNo">寵物：</label>
            <p-dropdown *ngIf="PetSelectList != null" [options]="PetSelectList" [(ngModel)]="model.PetNo" name="PetNo" 
                    placeholder="請選擇寵物" [showClear]="true"></p-dropdown>
          </div>

          <div class="field col-12">
            <label starSign class="notice">服務內容：</label>
            <p-scrollPanel [style]="{ width: '100%', height: '200px' }" styleClass="border-1 surface-border border-round">
              <div class="flex flex-column gap-2 p-2">
                <p-button *ngFor="let period of ServiceItemSelectList; let i = index" 
                  [label]="period.Service" [icon]="period.Icon" [disabled]="period.Disabled" 
                  [outlined]="period.Class !== ''" (onClick)="onSetService(i)" />
              </div>
            </p-scrollPanel>
          </div>
          <div class="field col-12">
            <label class="font-bold">總時程： <span class="text-primary text-xl">{{ TotalTimes }}分鐘</span></label>
          </div>
        </ng-container>

        <!-- 第二步內容 -->
        <ng-container *ngIf="Step === 2">
          <div class="field col-12">
            <label starSign class="notice" for="ResDate">預約日期：</label>
            <p-calendar id="ResDate" name="ResDate" 
              [(ngModel)]="model.ResDate" 
              [readonlyInput]="true" 
              (onClose)="changeResDate()" dateFormat="yy-mm-dd" 
              [minDate]="resMinDate"
              [disabledDates]="disabledDates" 
              [disabledDays]="disabledDays" 
              [disabled]="!CheckDateOpen()">
            </p-calendar>
            <small class="p-error" *ngIf="ErrorMsg_openTime">{{ ErrorMsg_openTime }}</small>
          </div>

          <div class="field col-12">
            <label starSign class="notice">預約時段：</label>
            <div *ngIf="storeOpenTimeList?.length; else noTimeTpl" class="time-grid-container mt-2">
              <div class="grid flex-wrap" *ngIf="ShowOrNotParam == '1'; else lineMsgTpl">
                <div class="col-4 p-1" *ngFor="let item of storeOpenTimeList">
                  <button type="button" class="time-btn w-full" 
                    [class.active]="model.ExpectedTime === item.value"
                    [disabled]="!CheckTimeOpen() || item.disabled"
                    (click)="selectTime(item.value)">{{item.label}}</button>
                </div>
              </div>
            </div>
            <ng-template #noTimeTpl><p class="p-error">{{ ErrorMsg }}</p></ng-template>
            <ng-template #lineMsgTpl><p class="p-info">{{ LineMsg }}</p></ng-template>
          </div>

          <div class="field col-12">
            <label class="font-bold">總金額： <span class="text-primary text-xl">{{ TotalPrice | currency:'TWD':'symbol':'1.0-0' }}</span></label>
            <p class="text-secondary text-sm" *ngIf="RemindStr" style="color: blue;">＊{{ RemindStr }}</p>
          </div>
        </ng-container>

        <!-- 按鈕控制區 -->
        <div class="field col-12 flex flex-column gap-2 mt-4">
          <app-button appClass="pageForm__btn w-full" (appClick)="nextStep(Step)" 
            [appLabel]="Step === 2 ? '確認' : '下一步'" 
            [loading]="isLoading" 
            [disabled]="Step === 1 ? !Step1Required() : !EditRequired()">
          </app-button>
          <app-button *ngIf="Step > 1" appClass="p-button-text w-full" (appClick)="prevStep()" appLabel="返回上一步"></app-button>
        </div>
      </form>
    </div>

    <!-- Step 3 & 4: 確認與完成頁面 -->
    <div *ngSwitchCase="Step === 3 || Step === 4 ? Step : -1" class="step-content">
      <div class="card p-4 shadow-1 border-round">
        <h5 class="text-center mb-4" *ngIf="Step === 4">{{UserName}}，預約成功！</h5>
        <h5 class="mb-3" *ngIf="Step === 3">請確認預約資訊：</h5>

        <div class="info-list flex flex-column gap-3">
          <div class="flex justify-content-between">
            <span class="text-secondary">預計日期：</span><span class="font-medium">{{editModel.ResDate}}</span>
          </div>
          <div class="flex justify-content-between">
            <span class="text-secondary">門市：</span><span class="font-medium">{{editModel.StoreName}}</span>
          </div>
          <div class="flex justify-content-between">
            <span class="text-secondary">寵物：</span><span class="font-medium">{{editModel.PetName}}</span>
          </div>
          <div class="flex justify-content-between">
            <span class="text-secondary">預約服務：</span><span class="font-medium">{{editModel.Services}}</span>
          </div>
          <div class="flex justify-content-between">
            <span class="text-secondary">預計時段：</span>
            <span class="font-medium" *ngIf="ShowOrNotParam !== '0'; else confirmLineMsg">
              {{editModel.ResTimeFrom}} ~ {{editModel.ResTimeTo}}
            </span>
          </div>
          <div class="flex justify-content-between border-top-1 surface-border pt-3 mt-2">
            <span class="text-secondary">預計費用：</span>
            <span class="text-primary font-bold text-xl">{{editModel.Price}}</span>
            <p class="text-secondary text-sm" *ngIf="RemindStr" style="color: blue;">＊{{ RemindStr }}</p>
          </div>
        </div>

        <div class="flex flex-column gap-2 mt-5">
          <app-button appClass="pageForm__btn w-full" (appClick)="nextStep(Step)" [appLabel]="Step === 3 ? '確認預約' : '回首頁'" [loading]="isLoading"></app-button>
          <app-button *ngIf="Step === 3" appClass="p-button-text w-full" (appClick)="prevStep()" appLabel="返回修改"></app-button>
        </div>
      </div>
    </div>

    <div *ngSwitchDefault class="text-center p-5">系統載入中...</div>
  </div>
</ng-container>

<!-- 共用樣式片段 -->
<ng-template #confirmLineMsg>
  <span class="p-error">{{ LineMsg }}</span>
</ng-template>
